// extracted by mini-css-extract-plugin
module.exports = {"star":"star_star__3hmOn","activeStar":"star_activeStar__2OYB9"};